module.exports = __webpack_public_path__ + "static/img/12.1.0364015.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/eng/12.1.png
// module id = IBzH
// module chunks = 0